import { FloatingOrb } from '../types';

interface FloatingOrbsProps {
  className?: string;
}

const FloatingOrbs = ({ className = '' }: FloatingOrbsProps) => {
  const orbs: FloatingOrb[] = [
    {
      id: 'orb-1',
      size: 400,
      left: '10%',
      top: '20%',
      animationDuration: '20s',
      animationDelay: '0s',
    },
    {
      id: 'orb-2',
      size: 300,
      left: '70%',
      top: '60%',
      animationDuration: '25s',
      animationDelay: '5s',
    },
    {
      id: 'orb-3',
      size: 350,
      left: '40%',
      top: '80%',
      animationDuration: '30s',
      animationDelay: '10s',
    },
  ];

  return (
    <div className={`fixed inset-0 z-[1] pointer-events-none overflow-hidden ${className}`}>
      {orbs.map((orb) => (
        <div
          key={orb.id}
          className="absolute rounded-full blur-3xl opacity-20"
          style={{
            width: `${orb.size}px`,
            height: `${orb.size}px`,
            left: orb.left,
            top: orb.top,
            background: 'radial-gradient(circle, var(--color-primary) 0%, transparent 70%)',
            animation: `float ${orb.animationDuration} ease-in-out infinite`,
            animationDelay: orb.animationDelay,
          }}
        />
      ))}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          25% {
            transform: translate(30px, -30px) scale(1.1);
          }
          50% {
            transform: translate(-20px, 20px) scale(0.9);
          }
          75% {
            transform: translate(20px, 30px) scale(1.05);
          }
        }
      `}</style>
    </div>
  );
};

export default FloatingOrbs;